import {
  put,
  all,
  takeEvery,
  take
} from 'redux-saga/effects';

export function * switchActiveCenter (payload) {
  yield put({ type: 'CONFIGURE_IDENTITY' });
  // wait for updated room and employee information before mmaking additional request
  yield put({ type: 'FETCH_ROOMS' });
  yield take('FETCH_ROOMS_SUCCESS');
  yield put({ type: 'FETCH_EMPLOYEES' });
  yield take('FETCH_EMPLOYEES_SUCCESS');

  yield all([
    put({ type: 'GET_SCHEDULES_REQUEST' }),
    put({ type: 'FETCH_EMPLOYEE_SHIFTS_REQUEST' }),
    put({ type: 'GET_TIME_OFF_REQUESTS_REQUEST' }),
    put({ type: 'GET_MENUS_REQUEST' }),
    put({ type: 'GET_EVENTS_REQUEST' }),
    put({ type: 'GET_CENTER_GALLERY_INFORMATION_REQUEST' })
  ]);
}

export const identitySagas = [
  takeEvery('SWITCH_ACTIVE_CENTER', switchActiveCenter)
];
